export default "__VITE_ASSET__BMBtpTKr__"